<template>
  <div class="has-tab">
    <!-- <Calendar></Calendar> -->
    <div class="swiper-box">
      <van-swipe :autoplay="3000" ref="swiper" :loop="true" :show-indicators='false'>
        <van-swipe-item v-for="(item,index) in banners" :key="index">
          <img :src="item" alt="" @click="toPage(index)"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="quick-entry">
      <div class="box-wrap">
        <div class="child" @click="$router.push({name: 'entrance'})">
          <img src="../../public/images/icons/index_icon01.png">
          <div class="text-content">
            <h3>体检预约</h3>
            <p>快捷预约通道</p>
          </div>
        </div>
        <div class="child" @click="entryFn(2)">
          <img src="../../public/images/icons/index_icon02.png">

          <div class="text-content">
            <h3>体检报告</h3>
            <p>快捷领取报告</p>
          </div>
        </div>
      </div>
      <div class="row row-wrap">
        <div class="col-4" @click="entryFn(3)">
          <img src="../../public/images/icons/tjzx_icon01.png"/>
          <p class="menu-tile">健康评估</p>
        </div>
        <router-link tag="a" to="/onlineCommunication/list" class="col-4 ">
          <img src="../../public/images/icons/tjzx_icon02.png"/>
          <p class="menu-tile">在线沟通</p>
        </router-link>
        <div class="col-4 " @click="entryFn(4)">
          <img src="../../public/images/icons/tjzx_icon03.png"/>
          <p class="menu-tile">专病专栏</p>
        </div>
      </div>
    </div>
    <Item class="program" v-if="false">
      <slot slot="item-left">
        <div>健康</div>
        <span>提醒</span>
      </slot>
      <slot slot="item-content">
        您的健康顾问为您制定了专属体检方案
      </slot>
      <slot slot="item-right">
        <i class="icon icon-arrow-right stable small"></i>
      </slot>
    </Item>
    <div class="medical-wrap">
      <Item>
        <slot slot="item-content">
          <h2>体检中心</h2>
          <div class="address" @click.stop="show=!show">
            <Icon name="icon-address" size="small"></Icon>
            {{ cityName }}
          </div>
        </slot>
        <slot slot="item-right">
          <div class="show-more" @click="showPopup=!showPopup">
            查看更多
            <Icon name="icon-arrow-right stable" size="small"></Icon>
          </div>
        </slot>
      </Item>
      <no-content v-if="!centerList.length" @click.native="show=!show"></no-content>
      <div class="child-wrap">
        <router-link :to="{ name: 'mec', params: { id: item.id }}" class="child" v-for="(item,index) in centerList"
                     :key="index">
          <img class="lazy-load" :src="getSysCenterImage(item)">
          <div>{{ item.name }}</div>
        </router-link>

      </div>
    </div>
    <div class="news-wrap">
      <Item headline="健康资讯">
        <slot slot="item-right">
          <router-link to="news/list" class="show-more">
            查看更多
            <Icon name="icon-arrow-right stable" size="small"></Icon>
          </router-link>
        </slot>
      </Item>
      <div class="list">
        <Item vTag="a" @click.stop="next(item)" v-for="(item,index) in newsList" :key="index" class="news-item"
              :thumb="item.picUrl" :title="item.title" :desc="item.source" cdn>
        </Item>
      </div>
    </div>
    <van-actionsheet
        v-model="show"
        :actions="cityList"
        @select="navClick"
    ></van-actionsheet>
    <sys-center-list :hasRouter="false" :showModal="showPopup" @itemClick="itemClick"
                     @navClick="navClick" @maskClick="closeSysCenterList"></sys-center-list>
  </div>
</template>

<script>
import { Tabs, Icon, Item, sysCenterList, NoContent, Calendar } from '@/components/common'
import { NEWS_LIST, BASE_URL } from '@/assets/scripts/api'
import { Location, Loading } from '@/assets/scripts/helper'
import GEOLOCAION from '@/assets/scripts/geolocaion/index'
import { Swipe, SwipeItem, Actionsheet } from 'vant'
import { IsWechat, InitWxConfig } from '@/assets/scripts/wechat/index'
import { mapState } from 'vuex'
import Vue from 'vue'
Vue.use(Swipe).use(SwipeItem).use(Actionsheet)

export default {
  data () {
    return {
      show: false, //显示城市列表
      selectCityId: '',
      newsList: [],
      showPopup: false,
      tabsItems: [
        {
          icon: 'icon-center-outline',
          iconActive: 'icon-center',
          title: '我的首页'
        },
        {
          icon: 'icon-cart-outline',
          iconActive: 'icon-cart',
          title: '我的订单'
        },
        {
          icon: 'icon-mine-outline',
          iconActive: 'icon-mine',
          title: '个人中心'
        }
      ],
      activeIndex: [0],
      banners: [
        BASE_URL + '/images/index_banner01.jpg',
        BASE_URL + '/images/index_banner03.jpg'
      ]
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'mec') { from.query.sid = to.params.id }
    next()
  },
  computed: {
    /* 首页体检中心展示列表数据 */
    ...mapState('center', {
      cityList: state => state.cityList || [],
      cityId: state => (state.sysCenter && state.sysCenter.cityId) || '',
      cityName: state => (state.position && state.position.name) || (state.sysCenter && state.sysCenter.cityName)
    }),
    ...mapState({
      initializeSid: state => state.initializeSid,
      sid: state => state.sid
    }),
    centerList () {
      let $this = this
      try {
        return this.cityList.find(item => $this.selectCityId ? item.id === $this.selectCityId : item.id === $this.cityId).children
      } catch (err) {
        return []
      }
    },
    hospitalList () {
      return (this.$store.state.center && this.$store.state.center.cityList ? this.$store.state.center.cityList : [])
    }
  },
  methods: {
    toPage (index) {
      if (index === 1) {
        this.$router.push({
          name: 'diseaseStartAssess',
          params: {id: '27', knowledgeId: 'ca63d586-d0d4-45c7-a2f9-1d6b2935b008'}
        })
      } else {
        this.$router.push({name: 'introduce'})
      }
    },
    next (item) {
      item.linkUrl ? Location(item.linkUrl) : this.$router.push({name: 'newsDetail', params: {id: item.id}})
    },
    onSelect (item) {
      // 点击选项时默认不会关闭菜单，可以手动关闭
      this.show = false
      Toast(item.name)
    },
    entryFn (type) {
      switch (type) {
        case 1:
          Location('/wx/index.html?sid=' + this.$store.state.sid + '#/questionnaire/entrance?id=' + this.$store.state.sid)
          break
        case 2:
          this.$router.push({name: 'reportList'})
          break
        case 3:
          this.$router.push({name: 'card'})
          //          Location('/wx/index.html?sid=' + this.$store.state.sid + '#/evaluation/list')
          break
        case 4:
          this.$router.push({name: 'specialDisease'})
          break
        case 5:
          Location('/wx/index.html?sid=' + this.$store.state.sid + '#/center/list/simple')
          break
      }
    },
    getSysCenterImage (item) {
      let imgUrl = this.$store.state.imageResourcesUrl + (item.image ? item.image.split(',')[0] : `/wx/img/img-center.png`)
      return imgUrl
    },
    tabClick (e) {
      if (e[0] === 1) {
        Location('/wx/index.html?sid=' + this.$store.state.sid + '#/order/list')
      } else if (e[0] === 2) {
        this.$router.push({name: 'personage'})
      }
    },
    navClick (e) {
      this.show = false
      this.$store.commit('center/setPosition', e)
      this.selectCityId = e.id
    },
    itemClick (e) {
      this.$router.push({name: 'mec', params: {id: e.id}})
    },
    closeSysCenterList () {
      this.showPopup = false
    }
  },
  created () {
    //    JsBarcode("#barcode", "Hi world!")
    if (!this.initializeSid) this.$store.commit('setInitializeSid', this.$route.query.sid || '00-0')
    if ((this.initializeSid && this.initializeSid !== '00-0') || this.$route.query.sid !== '00-0') {
      this.$router.replace({name: 'mec', params: {id: this.initializeSid === '00-0' ? this.$route.query.sid : this.initializeSid}})
    } else {
      if (this.$store.state.center.position && this.$store.state.center.position.name) {
        this.selectCityId = this.$store.state.center.position.id
      } else {
        if (IsWechat()) {
          InitWxConfig()
        }
        GEOLOCAION().then(data => {
          this.cityList.forEach(obj => {
            let {name, id} = obj
            if (data.city.indexOf(name) !== -1 || data.city.indexOf(name.substring(0, name.length - 1)) !== -1) {
              this.$store.commit('center/setPosition', obj)
              this.selectCityId = id
            }
          })
        })
      }
    }
  },
  mounted () {
    this.$axios.get(NEWS_LIST, {
      params: {
        '_BIZCODE': '0045',
        'paginationNo': 1,
        'paginationSize': 5
      }
    }).then(({data}) => {
      this.newsList = data.list || []
    })
  },
  components: {
    Icon,
    Tabs,
    Item,
    sysCenterList,
    NoContent,
    Calendar
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/style/variables.scss";

  .menu-tile {
    font-size: 16px;
  }

  .swiper-box {
    img {
      display: block;
      width: 100%;
    }
  }

  .quick-entry {
    background: $light;
    // float: left;
    // width: 100%;
    .box-wrap {
      display: flex;
      margin: 0 10px;
      border-radius: 10px;
      box-shadow: 0 0 6px $stable;
      padding: 15px 10px;
      background: $light;
      justify-content: space-between;
      transform: translate(0, -10px);
      .child {
        width: 50%;
        display: flex;
        align-items: center;
        padding: 0 10px;
        h3 {
          font-size: 18px;
          /*font-weight: normal;*/
          margin-bottom: 4px;
        }
        p {
          font-size: 11px;
          color: #999;
        }
        .text-content {
          padding-left: 8px;
        }
        img {
          width: 50px;
          height: 50px;
        }

      }
    }
    .row-wrap {
      font-size: 13px;
    }
    .row {
      padding: 10px;
      width: auto;
    }
    .col-4 {
      text-align: center;
      img {
        width: 40px;
      }
    }
  }

  div.health-item {
    margin: 10px 0;
  }

  .medical-wrap {
    padding: 5px 0 0;
    background: $light;
    margin: 10px 0;
    .item /deep/ {
      .item-content {
        display: flex;
        align-items: center;
      }
      .address {
        display: flex;
        /*<!--background: $grey;-->*/
        color: $dark09;
        margin-left: 10px;
        padding: 5px 10px 5px 5px;
        border-radius: 0 10px 10px;
        .icon{
          color: $assertive;
        }
      }
    }
  }

  .show-more {
    display: inline-flex;
    color: $dark06;
    .icon {
      margin-left: 3px;
    }
  }

  .col-center p {
    font-size: 16px;
  }

  .child-wrap {
    display: flex;
    /*white-space: nowrap;*/
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding: 0 5px 10px 5px;
    .child {
      color: $light;
      display: inline-block;
      /*padding: 0 5px;*/
      margin: 0 5px;
      font-size: 0;
      /*border:1px solid #dddddd;*/
      box-shadow: $darkDDD 0 0 10px;
      border-radius: 5px;
      img {
        height: 60px;
        width: 115px;
        display: block;
        border-top-right-radius: 5px ;
        border-top-left-radius: 5px ;
      }
      div{
        width: 115px;
        font-size: 14px;
        color: $dark09;
        text-align: center;
        /*height: 10px;*/
        display: block;
        padding: 5px;
        /*word-wrap:break-word;*/
        word-break:break-all;
      }
    }
  }

  .news-wrap {
    .news-item /deep/ {
      align-items: stretch;
      .item-content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
  }

  .program {
    margin-top: 10px;
  }
  .program /deep/ .item-content {
    color: #1a1a1a;
  }
  .program /deep/ .item-left {
    margin: 0 20px;
    font-size: 15px;
    font-weight: 600;
    color: $assertive;
    span {
      display: inline-block;
      color: $light;
      background: url("../../public/images/icons/program_icon.png") no-repeat;
      padding-right: 4px;
      background-size: 100% 100%;
    }
  }

</style>
